import { customErrorMessagesCommon } from "../Validation";
import Validator from "validatorjs";
import { IVehicle, IDriver } from "../../classes/Domain";
import { appValidator } from "../Validation";

const isEmpty = (str) => (!str?.length);

function notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
    return value !== null && value !== undefined;
}

const VALIDATION = {
    VEHICLE_REQUIRED: "Vehicle is required",
    VEHICLE_MAKE_REQUIRED: "Vehicle make is required",
    VEHICLE_MODEL_REQUIRED: "Vehicle model is required",
    VEHICLE_BODY_REQUIRED: "Vehicle body is required",
    VEHICLE_COVERAGES_REQUIRED: "Vehicle coverages is required",
    DRIVER_AGE_REQUIRED: "Driver age is required",
    DRIVER_MARITAL_STATUS_REQUIRED: "Driver marital status is required",
    DRIVER_LICENSE_STATUS_REQUIRED: "Driver license status is required",
    DRIVER_GENDER_REQUIRED: "Driver gender is required",
    DRIVER_ACCIDENTS_VIOLATIONS_REQUIRED: "Violations info is required",
    INCIDENT_VIOLATION_REQUIRED: "Violation is required"
};

Validator.registerImplicit('vehicle_required', function (this: any, value, requirement, attribute) {
    const vehicles = this.validator.input.vehicles as Array<IVehicle>;

    if (vehicles == null || vehicles.length === 0 || vehicles.some(x => x == null)) {
        return false;
    }

    return true;
});

Validator.registerImplicit('vehicle_make_required', function (this: any, value, requirement, attribute) {
    const vehicles = this.validator.input.vehicles as Array<IVehicle>;

    if (vehicles.filter(notEmpty).some(x => isEmpty(x.make))) {
        return false;
    }

    return true;
});

Validator.registerImplicit('vehicle_model_required', function (this: any, value, requirement, attribute) {
    const vehicles = this.validator.input.vehicles as Array<IVehicle>;

    if (vehicles.filter(notEmpty).some(x => isEmpty(x.model))) {
        return false;
    }

    return true;
});

Validator.registerImplicit('vehicle_body_required', function (this: any, value, requirement, attribute) {
    const vehicles = this.validator.input.vehicles as Array<IVehicle>;

    if (vehicles.filter(notEmpty).some(x => isEmpty(x.body))) {
        return false;
    }

    return true;
});

Validator.registerImplicit('vehicle_coverages_required', function (this: any, value, requirement, attribute) {
    const vehicles = this.validator.input.vehicles as Array<IVehicle>;

    if (vehicles.filter(notEmpty).some(x => !x.coverages)) {
        return false;
    }

    return true;
});

Validator.registerImplicit('driver_age_required', function (this: any, value, requirement, attribute) {
    const drivers = this.validator.input.drivers as Array<IDriver>;

    if (drivers.filter(notEmpty).some(x => !x.age || x.age === 0)) {
        return false;
    }

    return true;
});

Validator.registerImplicit('driver_maritalStatus_required', function (this: any, value, requirement, attribute) {
    const drivers = this.validator.input.drivers as Array<IDriver>;

    if (drivers.filter(notEmpty).some(x => isEmpty(x.maritalStatus))) {
        return false;
    }

    return true;
});

Validator.registerImplicit('driver_licenseStatus_required', function (this: any, value, requirement, attribute) {
    const drivers = this.validator.input.drivers as Array<IDriver>;

    if (drivers.filter(notEmpty).some(x => isEmpty(x.currentLicenseStatus))) {
        return false;
    }

    return true;
});

Validator.registerImplicit('driver_gender_required', function (this: any, value, requirement, attribute) {
    const drivers = this.validator.input.drivers as Array<IDriver>;

    if (drivers.filter(notEmpty).some(x => isEmpty(x.gender))) {
        return false;
    }

    return true;
});

Validator.registerImplicit('driver_accidentsViolations_required', function (this: any, value, requirement, attribute) {
    const drivers = this.validator.input.drivers as Array<IDriver>;

    if (drivers.filter(notEmpty).some(x => !x.incidents)) {
        return false;
    }

    return true;
});

Validator.registerImplicit('driver_viol_vialation_required', function (this: any, value, requirement, attribute) {
    const drivers = this.validator.input.drivers as Array<IDriver>;

    if (drivers.filter(notEmpty).some(x => x.incidents?.filter(notEmpty).some(i => i.violationCode === ""))) {
        return false;
    }

    return true;
});

const rules = {
    vehicle: {
        year: 'vehicle_required',
        make: 'vehicle_make_required',
        model: 'vehicle_model_required',
        body: 'vehicle_body_required',
        coverages: 'vehicle_coverages_required'
    },
    driver: {
        age: 'driver_age_required',
        gender: 'driver_gender_required',
        maritalStatus: 'driver_maritalStatus_required',
        currentLicenseStatus: 'driver_licenseStatus_required',
        accidentsViolations: 'driver_accidentsViolations_required'
    },
    incidents: {
        violationCode: 'driver_viol_vialation_required'
    },
    contactInfo: {
        phone: ['required', 'valid_phone'],
        email: ['email']
    }
};

const customErrorMessages = {
    "vehicle_required": VALIDATION.VEHICLE_REQUIRED,
    "vehicle_make_required": VALIDATION.VEHICLE_MAKE_REQUIRED,
    "vehicle_model_required": VALIDATION.VEHICLE_MODEL_REQUIRED,
    "vehicle_body_required": VALIDATION.VEHICLE_BODY_REQUIRED,
    "vehicle_coverages_required": VALIDATION.VEHICLE_COVERAGES_REQUIRED,
    "driver_age_required": VALIDATION.DRIVER_AGE_REQUIRED,
    "driver_maritalStatus_required": VALIDATION.DRIVER_MARITAL_STATUS_REQUIRED,
    "driver_licenseStatus_required": VALIDATION.DRIVER_LICENSE_STATUS_REQUIRED,
    "driver_gender_required": VALIDATION.DRIVER_GENDER_REQUIRED,
    "driver_accidentsViolations_required": VALIDATION.DRIVER_ACCIDENTS_VIOLATIONS_REQUIRED,
    "driver_viol_vialation_required": VALIDATION.INCIDENT_VIOLATION_REQUIRED
};

export const allFieldsValidation = (data) => {
    return appValidator.validate(data, rules, { ...customErrorMessagesCommon, ...customErrorMessages });
};